import React from 'react'
import CompleteAssessmentIcon from '../../app/components/svgIcons/CompleteAssessmentIcon'
import { StyledLabel } from '../../assets/styledComponents/Global'
import { useTheme } from 'styled-components'
import StyledButton from '../../app/components/styledComponents/StyledButton'
import { useWindowSize } from '../../utils/helper'

const AssessmentComplete = ({ videoProfileRes }) => {
    const theme = useTheme()

    const isSmallScreen = useWindowSize();
    return (

        <div
            className={`d-flex align-items-center  flex-column ${isSmallScreen && 'mt-5 pt-5 h-100'
                } `}
        >
            <CompleteAssessmentIcon className={`${isSmallScreen && 'mt-5 pt-5'}`} />
            <StyledLabel size="24px" fontWeight="600" color={theme?.darktext} className="mt-4" >
                You are all done
            </StyledLabel>

            <StyledLabel size="15px" fontWeight="500" color={theme?.subText} className={`mt-4 text-center ${videoProfileRes?.videoApplication?.videoProfile?.endDescription?.length > 100 ? 'w-75' : 'w-100'}`}  >
                {videoProfileRes?.videoApplication?.videoProfile?.endDescription ? videoProfileRes?.videoApplication?.videoProfile?.endDescription : 'Thanks for taking the time to submit your video responses.  We look forward to reviewing your responses, and if you’re shortlisted, we’ll be in touch with the next steps. Keep an eye on your inbox for updates!'}
            </StyledLabel>

            {/* <StyledLabel size="15px" fontWeight="500" color={theme?.subText} className="mt-4 text-center w-50" >
                Our recruitment team will carefully review your answers. If you are shortlisted, we will contact you with further instructions, so please keep an eye on your email for updates.
            </StyledLabel> */}

            <StyledButton onClick={() => window.location.href = 'https://portal.occy.com/'} style={{ marginTop: 10 }}  >
                View Candidate Portal{' '}
            </StyledButton>


        </div>
    )
}

export default AssessmentComplete